import { environment } from './../../../environments/environment';
import { PregaoResposta } from './../../model/movimentacao/pregaoResposta';
import { Observable } from 'rxjs/Observable';
import { ItemPregao } from '../../model/movimentacao/pregao';
import { ItemCotacao } from './../../model/movimentacao/item-cotacao';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

const URL_PREGAO = environment.urlPregao;

@Injectable({
  providedIn: 'root'
})
export class PregaoService {
  private itemPregao: ItemPregao;

  constructor(private http: HttpClient) { }

  public validatedMinorPrice(itemCotacao: ItemCotacao): Observable<PregaoResposta> {
    this.itemPregao = this.pregaoFromItemCotacao(itemCotacao)
    return this.http.post<PregaoResposta>(
      URL_PREGAO,
      this.itemPregao
    )
  }
  public pregaoFromItemCotacao(itemCotacao: ItemCotacao): ItemPregao {
    let itemPregao: ItemPregao = {
      id: itemCotacao.id,
      codigoPro: itemCotacao.codigoPro,
      idCotacao: itemCotacao.cotacao,
      fkIdCotacao: itemCotacao.fkidCotacao,
      cnpjCliente: itemCotacao.cnpjClienteSG,
      preco: itemCotacao.precoTotal
    }
    return itemPregao
  }

  public deletarItensCotacao(id):Observable<any>{
    return this.http.delete(`${URL_PREGAO}/${id}`);
  }

}
